module.exports = __webpack_public_path__ + "img/academic.951def0.png";